// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://megacinemas-api.nuviotech.co`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://megacinemas-api.nuviotech.co`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const SALES_APP = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjNjNzM0ODk3LTc0OWMtNDMxNC1iY2I1LWE1MDU2YzRmMWY2MCIsImlhdCI6MTc0NjE3Mzc1NH0.KEZiCddGMNZI90XO_07ZOhMFsnyJIFWiUVGyVd3JI4k`
export const TOKEN = SALES_APP



// WEBPACK FOOTER //
// ./src/config/index.js